import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BarLinesChartComponent } from './bar-lines-chart.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [BarLinesChartComponent],
  declarations: [BarLinesChartComponent]
})
export class BarLinesChartModule { }
